import React from "react";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import IOSSwitch from "../IOSSwitch";
import { usePaymentTheme } from "../../respayment/hooks/usePaymentTheme";
import { useUser } from "src/business-types/grocery/components/UserContext";

interface OrderTypeToggleProps {
  isDelivery: boolean;
  setIsDelivery: (value: boolean) => void;
  orderId?: string;
}

const OrderTypeToggle: React.FC<OrderTypeToggleProps> = ({ isDelivery, setIsDelivery, orderId }) => {
  const { themeTextColor, getBgClass, themeBorderColor } = usePaymentTheme();
  const { userConfigration } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-6 w-full">
      {/* Order Type Toggle */}
      <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 w-full sm:w-auto">
        {/* Table Option */}
        <div
          className={`flex items-center gap-2 px-2.5 py-1 rounded-lg transition-all duration-200 border-2 cursor-pointer 
            ${!isDelivery ? `${themeBorderColor} bg-white ${themeTextColor} shadow-md scale-105` : `border-gray-200 bg-${getBgClass} text-white-500 hover:bg-gray-200`}`}
          onClick={() => setIsDelivery(false)}
        >
          <TableRestaurantIcon className="text-base sm:text-lg" />
          <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Table</span>
        </div>

        {/* Toggle Switch */}
        {deliveryFeeEnabled && (
          <>
            {/* Toggle Switch */}
            <div className="flex items-center justify-center">
              <IOSSwitch checked={isDelivery} onChange={(e: { target: { checked: boolean } }) => setIsDelivery(e.target.checked)} />
            </div>

            {/* Delivery Option */}
            <div
              className={`flex items-center gap-2 px-3 py-1 rounded-lg transition-all duration-200 border-2 cursor-pointer 
              ${isDelivery ? `${themeBorderColor} bg-white ${themeTextColor} shadow-md scale-105` : `border-gray-200 bg-${getBgClass} text-white-500 hover:bg-gray-200`}`}
              onClick={() => setIsDelivery(true)}
            >
              <DeliveryDiningIcon className="text-base sm:text-lg" />
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Delivery</span>
            </div>
          </>
        )}
      </div>

      {/* Order ID Badge */}
      <div className="flex items-center justify-center sm:justify-end gap-1 px-2 py-0 bg-gray-50 rounded-lg border border-gray-200 w-full sm:w-auto">
        <LocalMallIcon className="text-gray-400 text-lg sm:text-xl" />
        <div className="flex flex-col text-center sm:text-left">
          <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Order No</span>
          <span className={`text-sm sm:text-base font-bold ${themeTextColor}`}>{!orderId ? "New Order" : `#${orderId}`}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderTypeToggle;
